import { spacing } from '../tokens/tokens-base/properties/build/js/index.js';
import { styled } from '../_common/stitches/stitches.config.js';
const StyledWrapper = styled('div', {
  boxSizing: 'content-box',
  variants: {
    orientation: {
      vertical: {},
      horizontal: {}
    },
    inline: {
      true: {
        display: 'inline-block',
        verticalAlign: 'bottom'
      }
    }
  },
  compoundVariants: [{
    orientation: 'horizontal',
    inline: true,
    css: {
      width: spacing.inner.base06,
      verticalAlign: 'middle'
    }
  }, {
    orientation: 'vertical',
    inline: true,
    css: {
      height: spacing.layout.base03
    }
  }]
});
const StyledDivider = styled('div', {
  variants: {
    orientation: {
      vertical: {
        height: '100%',
        width: '1px'
      },
      horizontal: {
        height: '1px',
        width: '100%'
      }
    }
  }
});
export { StyledDivider, StyledWrapper };